module.exports = __webpack_public_path__ + "02_medium_grey.a4c43c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_medium_grey.png
// module id = Mudh
// module chunks = 0